import React from 'react';

import DLPCarousel from './dlp-carousel';
import DLPIntelContainer from './dlp-intel-container';
import SEOLinks from '../../page/components/seo-links/seo-links';
import RelatedPages from '../../related-pages/components/related-pages';
import Icon from '../../ui/components/icon';
import { Helpers } from '../../core/src/helpers';
import { memoizedFormatMetricValue } from '../../metrics/metrics-helpers';
import { Typography, Link } from '@hpi-sox/hpstellar-core';

class DLPFooter extends React.Component {
    render() {
        const { pageInfo, match = {}, wordCloud, hideRelatedPages, intelBanner, title = 'Related Pages' } = this.props;

        // templateKey becomes dlp-v2 in the variation. This ensures we search
        // using the 'dlp' template key instead
        let modifiedPageInfo = { ...pageInfo };
        modifiedPageInfo.templateKey = 'dlp';

        return (
            <div className="dlp-footer">
                {!hideRelatedPages && (
                    <RelatedPages
                        pageInfo={modifiedPageInfo}
                        keyword={`${match.params.slug}:relatedPages`}
                        _source={['title', 'vanityUrl']}
                        resultMapper={({ _source }) => {
                            const { title: name, vanityUrl: url } = _source;
                            return {
                                name,
                                url: `/${url}`,
                            };
                        }}
                    >
                        {({ relatedPages }) =>
                            relatedPages instanceof Array &&
                            relatedPages.length > 0 && (
                                <div className="dlp-related-pages">
                                    <Typography variant="boldM" tag="h2" className="heading" isCaps>
                                        {title}
                                    </Typography>
                                    {relatedPages.map(
                                        relatedPages =>
                                            relatedPages && (
                                                <span className="dlp-related-page-link">
                                                    <Icon size={20} name="right_small" className="chevron-icon" />
                                                    <Link
                                                        type="body"
                                                        size="small"
                                                        to={Helpers.getBasenameRelativePath(relatedPages.url)}
                                                        color="dark"
                                                        data-gtm-category="linkClick"
                                                        data-gtm-id="product"
                                                        data-gtm-value={memoizedFormatMetricValue(relatedPages.name)}
                                                    >
                                                        {relatedPages.name}
                                                    </Link>
                                                </span>
                                            )
                                    )}
                                </div>
                            )
                        }
                    </RelatedPages>
                )}
                <DLPCarousel />
                {intelBanner && <DLPIntelContainer type="mobile" />}
                {wordCloud && wordCloud.length > 0 && <SEOLinks links={wordCloud} className="v2" />}
            </div>
        );
    }
}

export default DLPFooter;
